import './MyApps.css';
import { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import AppDetails, { AppRecord } from '../components/AppDetails';
import PlaceHolder from '../components/PlaceHolder';
import Dialog from '../components/Dialog';
import { getAppList } from '../service/apiServices';
import { useAzureData } from '../context/AzureContext';
import { errorMessages } from '../utilities/constants';
import { KeyRound } from 'lucide-react';
import LoadingBox from '../components/LoadingBox';

function ManageAppRequests() {
  const { apiToken } = useAzureData();
  const [apps, setApps] = useState<AppRecord[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<any>(null);

  const fetchApps = async () => {
    try {
      setIsLoading(true);
      const result = await getAppList(apiToken);

      const updatedData: AppRecord[] = result.onboarding_data.map((item: any) => ({
        ...item,
        environment: item.environment || '-',
        adgroupforappaccess: Array.isArray(item.adgroupforappaccess)
          ? item.adgroupforappaccess
          : item.adgroupforappaccess
          ? [item.adgroupforappaccess]
          : [],
        model_name: item.model_name || [],
        spn_appid_env_map: item.spn_appid_env_map || [],
        requested_on: item.created_on,
        requested_by: item.requested_by || 'N/A'
      }));

      setApps(updatedData);
    } catch (error: any) {
      setErrorMessage(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchApps();
  }, [apiToken]);

  if (errorMessage) {
    if (errorMessage.message === 'UNAUTHORIZED') {
      return <Dialog />;
    } else if (errorMessage.message === 'NOT_FOUND') {
      return <PlaceHolder message="No application requests available." />;
    } else {
      return <PlaceHolder message={parse(errorMessages.serverError)} />;
    }
  }

  if (isLoading)
    return (
      <div
        style={{ height: '100vh' }}
        className="container-fluid d-flex justify-content-center align-items-center">
        {/* <h4 className="text-center">Loading...</h4> */}
        <LoadingBox />
      </div>
    );

  return (
    <div className="myapps-container">
      {/* Header section */}
      <div className="app-details-header">
        <div className="header-left">
          <div className="title-row">
            <KeyRound size={20} strokeWidth={1.5} color="#1C64F2" />
            <span className="page-title" style={{ marginLeft: '2px' }}>
              Manage App Requests
            </span>
          </div>
          <p className="page-subtitle">
            Handle requests from users to create or update apps – review and respond as needed.
          </p>
        </div>
      </div>

      {/* AppDetails Table or Placeholder */}
      {apps.length > 0 ? (
        <AppDetails appList={apps} showRequestColumns={true} refetchApps={fetchApps} />
      ) : (
        <PlaceHolder message="No application requests found." />
      )}
    </div>
  );
}

export default ManageAppRequests;
